import './Banner.css'
import React from 'react'

import Link from './Link'

import { ICONHomeBanner, ICONFeaturesBanner } from '../icons'



export default ({ title, subtitle, description, buttonText, buttonUrl, children, icon = 'home' }) => {
    
    const FeaturesBanner = icon === 'home'
        ? ICONHomeBanner
        : icon === 'features'
            ? ICONFeaturesBanner
            : ''


    function createIcon() {
        return { __html: FeaturesBanner };
    }

    
    return <section className='banner'>
        <div className='banner-image'>
            <div dangerouslySetInnerHTML={createIcon()} />
        </div>
        <div className='container'>
            <div className='banner-content'>
                {subtitle && <h2>{subtitle}</h2>}
                {title && <h1>{title}</h1>}
                {description && <p>{description}</p>}
                {buttonText && buttonUrl && <Link className='button' to={buttonUrl}>{buttonText}</Link>}
            </div>
        </div>
        { children }
    </section>
}
    


// WEBPACK FOOTER //
// ./src/components/Banner.js